import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const tenantInvitationMenuRegistry = {
    core_tenantInvitation: {
        label: "Tenant Invitation",
        link: PAGE_URL.TENANT_INVITATION_PAGE,
        key: PAGE_URL.TENANT_INVITATION_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default tenantInvitationMenuRegistry;
